import React from 'react';
import type { OverlayMode, OverlaySelection } from './types';

type Variant = 'detail' | 'grid';

const labelStyle = (variant: Variant): React.CSSProperties => ({
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  cursor: 'pointer',
  fontSize: variant === 'grid' ? '0.9rem' : undefined,
});

export const OverlayModeSelector: React.FC<{
  overlay: OverlaySelection;
  onToggle: (mode: OverlayMode) => void;
  variant?: Variant;
  hasKeypoints?: boolean;
  hasWeights?: boolean;
}> = ({ overlay, onToggle, variant = 'detail', hasKeypoints = false, hasWeights = false }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: variant === 'grid' ? '0.75rem' : '1rem',
      marginBottom: variant === 'grid' ? 0 : 16,
      flexWrap: 'wrap',
    }}
  >
    <span style={{ fontSize: '0.9rem', fontWeight: 500 }}>Show on image:</span>
    <label style={labelStyle(variant)}>
      <input
        type="checkbox"
        checked={overlay.bboxes}
        onChange={() => onToggle('bboxes')}
      />
      Bboxes
    </label>
    <label style={labelStyle(variant)}>
      <input
        type="checkbox"
        checked={overlay.classifications}
        onChange={() => onToggle('classifications')}
      />
      Classifications
    </label>
    {hasKeypoints && (
      <label style={labelStyle(variant)}>
        <input
          type="checkbox"
          checked={overlay.keypoints}
          onChange={() => onToggle('keypoints')}
        />
        Keypoints
      </label>
    )}
    {hasWeights && (
      <label style={labelStyle(variant)}>
        <input
          type="checkbox"
          checked={overlay.weights}
          onChange={() => onToggle('weights')}
        />
        Weight
      </label>
    )}
  </div>
);
